import { locateRow } from "../find";
import { isRow } from "../sections";
import { clampSectionInsertIndex } from "../row-policy";
import type { DocumentSection } from "../types";
import type { EditorDraft } from "./types";
import { applySelectionChange } from "./draft";

export function applySectionSelection(
  draft: EditorDraft,
  section: DocumentSection,
): void {
  if (isRow(section)) {
    applySelectionChange(draft, { kind: 'row', rowId: section.id });
    return;
  }
  applySelectionChange(draft, { kind: 'group', groupId: section.id });
}

export function resolveTopLevelInsertIndex(
  draft: EditorDraft,
  explicitIndex?: number,
): number {
  if (explicitIndex !== undefined) {
    return clampSectionInsertIndex(draft.document.sections, explicitIndex);
  }

  let targetIndex = draft.document.sections.length;
  const { selection } = draft;
  if (selection.kind === 'row') {
    const located = locateRow(draft.document.sections, selection.rowId);
    if (located?.location.parent === 'document') {
      targetIndex = located.location.sectionIndex + 1;
    } else if (located?.location.parent === 'group') {
      const { groupId } = located.location;
      const groupIndex = draft.document.sections.findIndex(
        section => section.id === groupId,
      );
      if (groupIndex >= 0) {
        targetIndex = groupIndex + 1;
      }
    }
  } else if (selection.kind === 'group') {
    const groupIndex = draft.document.sections.findIndex(
      section => section.id === selection.groupId,
    );
    if (groupIndex >= 0) {
      targetIndex = groupIndex + 1;
    }
  }
  return clampSectionInsertIndex(draft.document.sections, targetIndex);
}
